import { makeStyles } from '@rbx/ui';

const usePermissionsContainerStyles = makeStyles()(() => ({
  permissions: {
    marginTop: 24,
    marginBottom: 0,
    paddingLeft: 24,
  },

  description: {
    marginTop: 24,
  },
}));

export default usePermissionsContainerStyles;
